import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-app_icon-22",
  "use": "icon-app_icon-22-usage",
  "viewBox": "0 0 36 37",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 37\" id=\"icon-app_icon-22\"><g><path d=\"M32.134 5.461a2 2 0 01.136 1.185l-4.753 24.958a2 2 0 01-2.975 1.352l-12.768-7.472 14.068-14.692L8.352 23.48l-6.025-3.524a2 2 0 01.2-3.555L29.495 4.443a2 2 0 012.639 1.018z\" /><path d=\"M11.828 25.433v7.416a1 1 0 001.824.567L27 14 11.828 25.433z\" fill-opacity=\".6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol